export default __webpack_public_path__ + "static/media/telegram.acfdae47.svg";